// Colombia World Cup 2026 Theme - Only Colombia for now
export const worldCupThemeAssets = {
  colombia: {
    id: 'colombia',
    name: 'Colombia',
    flag: '🇨🇴',
    // Brand colors
    yellow: '#FCD116',
    blue: '#003893',
    red: '#CE1126',
    // Primary/secondary for compatibility
    primary: '#FCD116',
    secondary: '#003893',
    tertiary: '#CE1126',
    // Images (all in /world_cup/)
    bgStadium: '/world_cup/Fondo.jpeg',                                      // Estadio Colombia con confeti (NUEVO)
    bgBall: '/world_cup/32005d9f-8a73-4a14-aa06-aeb92798439e.png',          // Ball with golden splash
    brushTopLeft: '/world_cup/960bd599-97b2-4c60-8ac7-0a023592c0b8.png',    // Flag brush top-left
    brushBottomRight: '/world_cup/67bc6284-2426-43d7-a1f7-8034d0b013c5.png', // Flag brush bottom-right
    // Gradient shortcuts
    flagGradient: 'linear-gradient(135deg, #FCD116 0%, #FCD116 33%, #003893 33%, #003893 66%, #CE1126 66%, #CE1126 100%)',
    flagGradientVertical: 'linear-gradient(to bottom, #FCD116 0%, #FCD116 50%, #003893 50%, #003893 75%, #CE1126 75%, #CE1126 100%)',
    isDarkMode: false,
  }
};
